// @ts-nocheck

export const useSmoothScroll = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const rect = element.getBoundingClientRect();
      const headerHeight = 80;
      const targetPosition = window.pageYOffset + rect.top - headerHeight;

      // Se já estiver na posição correta, não fazer scroll
      if (Math.abs(window.pageYOffset - targetPosition) < 10) {
        return;
      }

      // Implementação manual de scroll suave
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = Math.min(Math.abs(distance) * 0.8, 1000); // Duração proporcional à distância
      let start: number | null = null;
      let animationId: number | null = null;

      const step = (timestamp: number) => {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const percentage = Math.min(progress / duration, 1);

        // Easing function suave (ease-out-quad)
        const ease = 1 - (1 - percentage) * (1 - percentage);

        const currentPosition = startPosition + distance * ease;
        window.scrollTo(0, currentPosition);

        if (progress < duration) {
          animationId = window.requestAnimationFrame(step);
        } else {
          // Garantir que chegou na posição exata
          window.scrollTo(0, targetPosition);
        }
      };

      // Cancelar animação anterior se existir
      if (animationId) {
        window.cancelAnimationFrame(animationId);
      }

      animationId = window.requestAnimationFrame(step);
    }
  };

  const scrollToElement = (elementRef: React.RefObject<HTMLElement>) => {
    if (elementRef.current) {
      const rect = elementRef.current.getBoundingClientRect();
      const headerHeight = 80;
      const targetPosition = window.pageYOffset + rect.top - headerHeight;

      // Se já estiver na posição correta, não fazer scroll
      if (Math.abs(window.pageYOffset - targetPosition) < 10) {
        return;
      }

      // Implementação manual de scroll suave
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = Math.min(Math.abs(distance) * 0.8, 1000); // Duração proporcional à distância
      let start: number | null = null;
      let animationId: number | null = null;

      const step = (timestamp: number) => {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const percentage = Math.min(progress / duration, 1);

        // Easing function suave (ease-out-quad)
        const ease = 1 - (1 - percentage) * (1 - percentage);

        const currentPosition = startPosition + distance * ease;
        window.scrollTo(0, currentPosition);

        if (progress < duration) {
          animationId = window.requestAnimationFrame(step);
        } else {
          // Garantir que chegou na posição exata
          window.scrollTo(0, targetPosition);
        }
      };

      // Cancelar animação anterior se existir
      if (animationId) {
        window.cancelAnimationFrame(animationId);
      }

      animationId = window.requestAnimationFrame(step);
    }
  };

  return { scrollToSection, scrollToElement };
};
